import { showNotification } from "@mantine/notifications";

export default function receiveMessageListener(message: string) {
  console.log("Received message:", message);
  showNotification({
    title: "System Global Message",
    message,
    color: "teal",
    autoClose: 5000,
  });
}
